"use strict";

/**
 *  Steda Attribution Tracking
 *
 *  Speichert First-Touch- und Last-Touch-Attribution-Daten in localStorage.
 *  Keine personenbezogenen Daten – nur Kampagnen-/Quell-Parameter.
 *
 *  Lifecycle:
 *    1. Beim ersten Seitenaufruf → First-Touch speichern (wird NIE überschrieben)
 *    2. Bei jedem weiteren Aufruf → Last-Touch aktualisieren
 *    3. Beim Checkout → getAttributionPayload() liefert das gesamte Objekt
 */

;
(function () {
  'use strict';

  var STORAGE_KEY = 'steda_attribution';

  // ─── Tracked UTM / Click-ID Parameter ──────────────────────────────

  var TRACKED_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gad_source', 'gad_campaignid', 'fbclid'];

  // ─── Helpers ───────────────────────────────────────────────────────

  /**
   *  Parse query string aus einem URL-String.
   *  Gibt ein einfaches Key/Value-Objekt zurück.
   */
  function parseQueryParams(url) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url || window.location.href;
    var search = parser.search || '';
    if (search.indexOf('?') === 0) {
      search = search.substring(1);
    }
    if (!search) {
      return params;
    }
    var pairs = search.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var idx = pairs[i].indexOf('=');
      if (idx === -1) continue;
      var key = decodeURIComponent(pairs[i].substring(0, idx));
      var value = decodeURIComponent(pairs[i].substring(idx + 1));
      if (key) {
        params[key] = value;
      }
    }
    return params;
  }

  /**
   *  Prüfe ob ein Referrer extern ist (andere Domain).
   */
  function isExternalReferrer(referrer) {
    if (!referrer) return false;
    try {
      var refHost = new URL(referrer).hostname;
      var ownHost = window.location.hostname;
      return refHost !== ownHost;
    } catch (e) {
      return false;
    }
  }

  /**
   *  Extrahiere Attribution-Daten aus der aktuellen URL.
   *  Gibt null zurück wenn keine relevanten Parameter vorhanden sind.
   */
  function getAttributionFromUrl() {
    var params = parseQueryParams(window.location.href);
    var data = {};
    var hasParams = false;
    for (var i = 0; i < TRACKED_PARAMS.length; i++) {
      var key = TRACKED_PARAMS[i];
      if (params[key]) {
        data[key] = params[key];
        hasParams = true;
      }
    }
    if (!hasParams) {
      return null;
    }
    return data;
  }

  /**
   *  Lade gespeicherte Attribution aus localStorage.
   *  Gibt ein leeres Objekt zurück wenn nichts vorhanden.
   */
  function loadAttribution() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        return JSON.parse(raw);
      }
    } catch (e) {
      // Korrupte Daten → ignorieren
    }
    return {};
  }

  /**
   *  Speichere Attribution-Daten in localStorage.
   */
  function saveAttribution(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      // localStorage voll / nicht verfügbar
    }
  }

  /**
   *  First-Touch speichern – nur wenn noch kein First-Touch existiert.
   *  Erfasst: landing_page, referrer (nur extern), UTMs, Click-IDs, Timestamp.
   */
  function saveFirstTouchIfMissing() {
    var stored = loadAttribution();

    // First-Touch existiert bereits → nicht überschreiben
    if (stored.first_touch) {
      return stored;
    }
    var urlData = getAttributionFromUrl() || {};
    var referrer = document.referrer || '';
    stored.first_touch = {
      landing_page: window.location.pathname + window.location.search,
      referrer: isExternalReferrer(referrer) ? referrer : '',
      utm_source: urlData.utm_source || '',
      utm_medium: urlData.utm_medium || '',
      utm_campaign: urlData.utm_campaign || '',
      utm_term: urlData.utm_term || '',
      utm_content: urlData.utm_content || '',
      gclid: urlData.gclid || '',
      gad_source: urlData.gad_source || '',
      gad_campaignid: urlData.gad_campaignid || '',
      fbclid: urlData.fbclid || '',
      timestamp: new Date().toISOString()
    };
    saveAttribution(stored);
    return stored;
  }

  /**
   *  Last-Touch aktualisieren – bei jedem Seitenaufruf mit neuen UTMs.
   *  Falls keine neuen UTMs vorhanden: nur Timestamp aktualisieren.
   */
  function updateLastTouch() {
    var stored = loadAttribution();
    var urlData = getAttributionFromUrl();
    if (!stored.last_touch) {
      stored.last_touch = {};
    }
    stored.last_touch.timestamp = new Date().toISOString();
    stored.last_touch.landing_page = window.location.pathname + window.location.search;
    var referrer = document.referrer || '';
    stored.last_touch.referrer = isExternalReferrer(referrer) ? referrer : '';

    // UTMs nur überschreiben wenn in der URL vorhanden
    if (urlData) {
      for (var i = 0; i < TRACKED_PARAMS.length; i++) {
        var key = TRACKED_PARAMS[i];
        if (urlData[key]) {
          stored.last_touch[key] = urlData[key];
        }
      }
    }
    saveAttribution(stored);
    return stored;
  }

  /**
   *  Komplett-Payload für den Checkout.
   *  Gibt ein Objekt mit first_touch und last_touch zurück.
   */
  function getAttributionPayload() {
    var stored = loadAttribution();
    return {
      first_touch: stored.first_touch || null,
      last_touch: stored.last_touch || null
    };
  }

  // ─── Initialisierung ───────────────────────────────────────────────

  function init() {
    saveFirstTouchIfMissing();
    updateLastTouch();
  }

  // ─── Public API ────────────────────────────────────────────────────

  window.StedaAttribution = {
    parseQueryParams: parseQueryParams,
    getAttributionFromUrl: getAttributionFromUrl,
    loadAttribution: loadAttribution,
    saveFirstTouchIfMissing: saveFirstTouchIfMissing,
    updateLastTouch: updateLastTouch,
    getAttributionPayload: getAttributionPayload,
    init: init
  };

  // Auto-Init sobald das DOM bereit ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();